import { render } from "./ModelMeta.vue?vue&type=template&id=5c8f20c3"
import script from "./ModelMeta.vue?vue&type=script&lang=js"
export * from "./ModelMeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__